module.exports = __webpack_public_path__ + "static/media/visual-events.dd032d30.png";